import type {
  AccessibilityWizardPanelState,
  InitialData,
} from '@wix/a11y-wizard';

import type { A11yWizardState } from './types';

export interface A11yWizardSelectors {
  getInitialData: () => InitialData | undefined;
  getPanelState: () => AccessibilityWizardPanelState | undefined;
}

export const createA11yWizardSelector = (
  getState: () => A11yWizardState,
): A11yWizardSelectors => ({
  getInitialData: () => getState().initialData,
  getPanelState: () => getState().panelState,
});
